import "./PageObjectPlan.scss"
import React, {useEffect, useState} from "react";
import {TopRightNav} from "../cmp/header/TopRightNav";
import {YearSlider} from "../cmp/year/parts/YearSlider";
import {UnitRoomFilter} from "../cmp/unit/UnitRoomFilter";
import {useUnitsState} from "../store/UnitsState";
import {useParams} from "react-router";
import {IObject} from "../interfaces/IObject";
import {IAvailableUnit} from "../interfaces/IAvailableUnit";
import {AvailableUnitCard} from "../cmp/unit/AvailableUnitCard";
import {BreadCrumbs} from "../cmp/header/BreadCrumbs";

export function PageObjectPlan() {

  const store = useUnitsState()
  let params = useParams<{ object_name: string }>();
  let [object, setObject] = useState<IObject | undefined>(undefined);
  let [units, setUnits] = useState<IAvailableUnit[]>([]);

  useEffect(() => {
    if (store.loading) return
    if (params.object_name) {
      const _object = store.objects.find(o => o.name === params.object_name)
      if (_object) {
        setObject(_object)
        const _units = store.units.filter(u =>
          Number(u.object_id) === Number(_object.id) && u.unit_type_category === "apartments"
        )
        setUnits(_units)
      }
    }
  }, [store.loading])

  if (store.loading || !object) {
    return null
  }

  return <div id="app-storefront-floor">

    <header>
      <section>
        <BreadCrumbs object={object} />
        <div data-component="TopRightNav"><TopRightNav/></div>
      </section>
      <h1>Планування {object.name}</h1>
      <div data-component='YearSlider'>
        <YearSlider header={true} navigate={false}/>
      </div>

      <div data-component='UnitRoomFilter'>
        <UnitRoomFilter
          houses={2} rooms1={1} rooms2={2} rooms3={3} rooms4p={4}
          active1={true} active2={true} active3={true} active4p={true}
        />
      </div>
    </header>
    <main>

      {units.map(u => <div key={u.unit_id}>
        <AvailableUnitCard unit={u} floorSelector={true}/>
      </div>)}
      {/*<h4>1-кімнатні від 2.96 млн грн</h4>*/}

      {/*<div className="flat-card">*/}
      {/*  <img src="https://res.cloudinary.com/estoffice-com/image/upload/f_webp,fl_awebp,q_auto/v1736242520/default_img_flat" alt="floorplan"/>*/}
      {/*  <section>*/}
      {/*    <label className="details">44.2 м2 · 1-кімнатна</label>*/}
      {/*    ·*/}
      {/*    <label className="floor">6 поверх</label>*/}
      {/*    ·*/}
      {/*    <label className="apts">5 квартир</label>*/}
      {/*  </section>*/}
      {/*  <h4>2.96 млн грн</h4>*/}
      {/*  <section>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        Будівля 7.2 Aqua*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-crane></icon-crane>*/}
      {/*        Будується*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        <icon-calendar-sm></icon-calendar-sm>*/}
      {/*        3 кв 2025*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-currency-sq></icon-currency-sq>*/}
      {/*        64 950 грн/м²*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </section>*/}
      {/*</div>*/}
      {/*<div className="flat-card">*/}
      {/*  <img src="https://res.cloudinary.com/estoffice-com/image/upload/f_webp,fl_awebp,q_auto/v1736242520/default_img_flat" alt="floorplan"/>*/}
      {/*  <section>*/}
      {/*    <label className="details">44.2 м2 · 1-кімнатна</label>*/}
      {/*    ·*/}
      {/*    <label className="floor">6 поверх</label>*/}
      {/*    ·*/}
      {/*    <label className="apts">5 квартир</label>*/}
      {/*  </section>*/}
      {/*  <h4>2.96 млн грн</h4>*/}
      {/*  <section>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        Будівля 7.2 Aqua*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-crane></icon-crane>*/}
      {/*        Будується*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        <icon-calendar-sm></icon-calendar-sm>*/}
      {/*        3 кв 2025*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-currency-sq></icon-currency-sq>*/}
      {/*        64 950 грн/м²*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </section>*/}
      {/*</div>*/}
      {/*<div className="flat-card">*/}
      {/*  <img src="https://res.cloudinary.com/estoffice-com/image/upload/f_webp,fl_awebp,q_auto/v1736242520/default_img_flat" alt="floorplan"/>*/}
      {/*  <section>*/}
      {/*    <label className="details">44.2 м2 · 1-кімнатна</label>*/}
      {/*    ·*/}
      {/*    <label className="floor">6 поверх</label>*/}
      {/*    ·*/}
      {/*    <label className="apts">5 квартир</label>*/}
      {/*  </section>*/}
      {/*  <h4>2.96 млн грн</h4>*/}
      {/*  <section>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        Будівля 7.2 Aqua*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-crane></icon-crane>*/}
      {/*        Будується*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        <icon-calendar-sm></icon-calendar-sm>*/}
      {/*        3 кв 2025*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-currency-sq></icon-currency-sq>*/}
      {/*        64 950 грн/м²*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </section>*/}
      {/*</div>*/}
      {/*<div className="flat-card">*/}
      {/*  <img src="https://res.cloudinary.com/estoffice-com/image/upload/f_webp,fl_awebp,q_auto/v1736242520/default_img_flat" alt="floorplan"/>*/}
      {/*  <section>*/}
      {/*    <label className="details">44.2 м2 · 1-кімнатна</label>*/}
      {/*    ·*/}
      {/*    <label className="floor">6 поверх</label>*/}
      {/*    ·*/}
      {/*    <label className="apts">5 квартир</label>*/}
      {/*  </section>*/}
      {/*  <h4>2.96 млн грн</h4>*/}
      {/*  <section>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        <icon-apt-section></icon-apt-section>*/}
      {/*        Будівля 7.2 Aqua*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-crane></icon-crane>*/}
      {/*        Будується*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <label>*/}
      {/*        <icon-calendar-sm></icon-calendar-sm>*/}
      {/*        3 кв 2025*/}
      {/*      </label>*/}
      {/*      <label>*/}
      {/*        <icon-currency-sq></icon-currency-sq>*/}
      {/*        64 950 грн/м²*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </section>*/}
      {/*</div>*/}

    </main>

  </div>
}